/* eslint-disable no-restricted-globals */
import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { LayoutSplashScreen } from '../../_metronic/layout/core';

const Logout = () => {
	const getRootDomain = () => {
		const host = location.host.split(':')[0];
		if (
			/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(host)
		) {
			return host;
		} else if (host.indexOf('localhost') !== -1) {
			return 'localhost';
		} else {
			const temp = host.split('.').reverse();
			return '.' + temp[1] + '.' + temp[0];
		}
	};

	const getCookie = (name) => {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	};

	useEffect(() => {
		localStorage.removeItem('businessUnit');
		document.cookie = `MyToken=;path=/;domain=${getRootDomain()};expires=${new Date(0).toUTCString()}`;
		window.location.href = process.env.REACT_APP_LOGIN + "login/index/" + encodeURIComponent(window.btoa(process.env.REACT_APP_URL));
	}, []);

	const jwt = getCookie('MyToken');
	return jwt ? <LayoutSplashScreen /> : <Redirect to="/" />;
};

export default Logout;
